module.exports = __webpack_public_path__ + "static/media/authorised-staff.88e2e206.svg";